import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 7,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const AppointmentRegisterReport = ({ data }) => {
  console.log(data, 'RegisterData');

  // Function to format date as dd/mm/yyyy
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Assuming 'user' data is available in localStorage
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Appointment Register Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.textBold} content="Appointment Register Report" />
            </View>
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '9%' }} content="Sr No." />
              <Text style={{...styles.columnHeader, width:'12%'}} content="Date" />
              <Text style={{ ...styles.columnHeader, width: '9%' }} content="App No" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="City" />
              <Text style={styles.columnHeader} content="State" />
              <Text style={styles.columnHeader} content="Category" />
              <Text style={styles.columnHeader} content="Mobile No" />
              <Text style={styles.columnHeader} content="Service" />
              <Text style={{ ...styles.columnHeader, width: '17%' }} content="Entry By" />
            </View>
            {data &&
              data.opdData.data.map((item, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width:'11%' }} content={formatDate(item.createdAt)} />
                  <Text style={{ ...styles.columnContent, textAlign: 'center', width:'9%' }} content={item.app_no} />
                  <Text style={{ ...styles.columnContent, textAlign: 'start', width:'25%' }}
                    content={item.patient_name}
                  />
                  <Text style={{ ...styles.columnContent, textAlign: 'start' }} content={`${item.city.city}`} />
                  <Text style={{ ...styles.columnContent, textAlign: 'start' }} content={`${item.state.state}`} />
                  <Text style={{ ...styles.columnContent, textAlign: 'start' }} content={`${item.category.name}`} />
                  <Text style={{ ...styles.columnContent, textAlign: 'start' }} content={`${item.mobile}`} />
                  <Text style={{ ...styles.columnContent, textAlign: 'start' }} content={item.service} />
                  <Text style={{ ...styles.columnContent }} content={item.createdBy || 'N/A'} />
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
